import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";

const getMockups =
    ({ page = 0, sizeperpage = 0, search = "", filter = {} } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_MOCKUP", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            axios
                .get(`/api/mockup?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_MOCKUP", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "ADMIN_LIST_MOCKUP",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_MOCKUP", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };
const deleteMockup = (data) => (dispatch, getState) => {
    var body = {
        _id: data._id
    };
    Swal.fire({
        title: t("Are you sure?"),
        text: t("Are you sure to delete mockup?"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: t("Sure"),
        cancelButtonText: t("Cancel")
    }).then((result) => {
        if (result.value) {
            dispatch({ type: 'LOADING_MOCKUP', payload: true });
            axios.post('/api/mockup/delete', body, tokenConfig(getState)).then(res => {
                dispatch({ type: 'LOADING_MOCKUP', payload: false });
                if (res.data.status === 200) {
                    dispatch(getMockups());
                    Swal.fire(t("Success"), t(res.data.message), 'success');
                } else {
                    Swal.fire(t("Error"), t(res.data.message), 'error');
                }
            }).catch(err => {
                dispatch({ type: 'LOADING_MOCKUP', payload: false });
                Swal.fire(t("Error"), t("An error occurred!"), 'error');
            });
        }
    })
};

const mockupCreate = (data) => async (dispatch, getState) => {
    const options = {
        method: "POST",
        url: "/api/mockup/mockup-create",
        headers: {
            "Content-Type": "multipart/form-data; boundary=---011000010111000001101001",
            "al-token": getState().user.token,
        },
        data,
    };
    return axios.request(options).then(res => {
        if (res.data.status === 200) {
            Swal.fire(t("Success"), t(res.data.message), 'success');
            return "";
        } else {
            Swal.fire(t("Error"), t(res.data.message), 'error');
            return "";
        }
    }).catch(err => {
        Swal.fire(t("Error"), t("An error occurred!"), 'error');
        return ""
    });
};

const mockupGetDesign = (data) => async (dispatch, getState) => {
    var body = {
        designs_selected: data.designs_selected,
        mockups_selected: data.mockups_selected,
    };
    dispatch({ type: 'LOADING_MOCKUP', payload: true });
    axios.post('/api/mockup/mockup-design', body, tokenConfig(getState)).then(res => {
        dispatch({ type: 'LOADING_MOCKUP', payload: false });
        if (res.data.status === 200) {
            Swal.fire(t("Success"), t(res.data.message), 'success');
        } else {
            Swal.fire(t("Error"), t(res.data.message), 'error');
        }
    }).catch(err => {
        dispatch({ type: 'LOADING_MOCKUP', payload: false });
        Swal.fire(t("Error"), t("An error occurred!"), 'error');
    });
};

const getMockupGenerators =
    ({ page = 0, sizeperpage = 0, search = "", filter = {} } = {}) =>
        (dispatch, getState) => {
            dispatch({ type: "LOADING_MOCKUP", payload: true });
            var param_search = "";
            if (search !== "") {
                param_search = `&search=${search}`;
            }
            filter = new URLSearchParams(filter).toString();
            if (filter) filter = `&${filter}`
            axios
                .get(`/api/mockup/mockup-generator?page=${page}&sizeperpage=${sizeperpage}${param_search}${filter}`, tokenConfig(getState))
                .then((res) => {
                    dispatch({ type: "LOADING_MOCKUP", payload: false });

                    if (res.data.status === 200) {
                        dispatch({
                            type: "ADMIN_LIST_MOCKUP_GENERATOR",
                            payload: res.data.data,
                        });
                    } else {
                        Swal.fire(t("Error"), t(res.data.message), "error");
                    }
                })
                .catch((err) => {
                    dispatch({ type: "LOADING_MOCKUP", payload: false });
                    Swal.fire(t("Error"), t("An error occurred!"), "error");
                });
        };

export {
    getMockups,
    deleteMockup,
    mockupCreate,
    mockupGetDesign,
    getMockupGenerators,
}
